export interface DataReadable {
    Data: string;
    Readable: string;
}

export class ZASConstants {
    static SalutationSelectorTable = {
        tc_mr: "Herr",
        tc_mrs: "Frau",
        tc_mrandmrs: "Herr und Frau",
        tc_ladies: "Damen",
        tc_gentlemen: "Herren",
        tc_company: "Firma",
        tc_companymanagement: "Geschäftsleitung der Firma",
        tc_none: "Keine",
    };

    static SalutationTable = {
        tc_mr: "Herr",
        tc_mrs: "Frau",
    };

    static TitleOfNobilityTable = {
        tc_baron: "Baron",
        tc_baroness: "Baroness",
        tc_baronesse: "Baronesse",
        tc_baronin: "Baronin",
        tc_freifrau: "Freifrau",
        tc_freiherr: "Freiherr",
        tc_freiin: "Freiin",
        tc_fuerst: "Fürst",
        tc_fuerstin: "Fürstin",
        tc_graf: "Graf",
        tc_graefin: "Gräfin",
        tc_herzog: "Herzog",
        tc_herzogin: "Herzogin",
        tc_komtesse: "Komtesse",
        tc_markgraf: "Markgraf",
        tc_markgraefin: "Markgräfin",
        tc_prinz: "Prinz",
        tc_prinzessin: "Prinzessin",
        tc_edler: "Edler",
        tc_edle: "Edle",
        tc_ritter: "Ritter",
    };

    static AcademicDegreeTable = {
        tc_dr: "Dr.",
        tc_drdent: "Dr. dent.",
        tc_drdr: "Dr. Dr.",
        tc_drhc: "Dr. h.c.",
        tc_drjur: "Dr. jur.",
        tc_drmed: "Dr. med.",
        tc_drphil: "Dr. phil.",
        tc_drvet: "Dr. vet.",
        tc_prof: "Prof.",
        tc_profdr: "Prof. Dr.",
        tc_profdrdr: "Prof. Dr. Dr.",
        tc_drdrhc: "Dr. Dr. h.c.",
        tc_drmult: "Dr. mult.",
        tc_bsc: "B.Sc.",
        tc_msc: "M.Sc.",
        tc_ba: "B.A.",
        tc_mag: "Mag.",
        tc_di: "DI",
        tc_ing: "Ing.",
        tc_llb: "LL.B.",
        tc_llm: "LL.M.",
        none: "(ohne)",
    };

    static NameParticleTable = {
        tc_am: "am",
        tc_an: "an",
        tc_ander: "an der",
        tc_aus: "aus",
        tc_ausdem: "aus dem",
        tc_ausden: "aus den",
        tc_ausder: "aus der",
        tc_bel: "bel",
        tc_d_apos: "d'",
        tc_da: "da",
        tc_dal: "dal",
        tc_das: "das",
        tc_de: "de",
        tc_del: "del",
        tc_dela: "de la",
        tc_della: "della",
        tc_delle: "delle",
        tc_dem: "dem",
        tc_den: "den",
        tc_der: "der",
        tc_des: "des",
        tc_di: "di",
        tc_do: "do",
        tc_dos: "dos",
        tc_du: "du",
        tc_el: "El",
        tc_in: "in",
        tc_inden: "in den",
        tc_inder: "in der",
        tc_int_apos: "in t'",
        tc_l_apos: "l'",
        tc_la: "la",
        tc_le: "Le",
        tc_les: "les",
        tc_lo: "lo",
        tc_mac: "Mac",
        tc_mc: "Mc",
        tc_op: "op",
        tc_opde: "op de",
        tc_opden: "op den",
        tc_opt_apos: "op t'",
        tc_opten: "op ten",
        tc_saint: "Saint",
        tc_si: "si",
        tc_skt: "Skt.",
        tc_ten: "ten",
        tc_to: "to",
        tc_van: "van",
        tc_vande: "van de",
        tc_vandem: "van dem",
        tc_vanden: "van den",
        tc_vander: "van der",
        tc_vant_apos: "van t'",
        tc_vom: "vom",
        tc_von: "von",
        tc_vondem: "von dem",
        tc_vonden: "von den",
        tc_vonder: "von der",
        tc_vonzur: "von zur",
        tc_vor: "vor",
        tc_vordem: "vor dem",
        tc_vorden: "vor den",
        tc_vorder: "vor der",
        tc_vu: "vu",
        tc_zu: "zu",
        tc_zudem: "zu dem",
        tc_zuden: "zu den",
        tc_zuder: "zu der",
        tc_zum: "zum",
        tc_zur: "zur",
    };

    static NameSuffixTable = {
        tc_jr: "jun.",
        tc_sr: "sen.",
        tc_c_Ir: "Ir",
        tc_c_I: "I.",
        tc_c_II: "II.",
    };

    static LegalFormTable = {
        tc_ag: "AG",
        tc_anstaltoeffr: "Anstalt öff. R.",
        tc_bruchteilsgem: "Bruchteilsgem.",
        tc_eg: "e.G.",
        tc_egmbh: "eGmbH",
        tc_egmuh: "eGmuH",
        tc_ehegem: "Ehegem.",
        tc_eigentuemergemeinschaft: "Eigentümergemeinschaft",
        tc_einpersonenfirma: "Einpersonenfirma",
        tc_erbengemeinschaft: "Erbengemeinschaft",
        tc_ev: "e.V.",
        tc_gbr: "GbR",
        tc_gebietskoerpersch: " 	Gebietskörpersch.",
        tc_ggmbh: "gGmbH",
        tc_gmbh: "GmbH",
        tc_gmbhuco: "GmbH u. CO",
        tc_gmbhucokg: "GmbH u. CO KG",
        tc_hausverwaltung: "Hausverwaltung",
        tc_kaufmmithr: " 	Kaufm. mit HR",
        tc_kaufmohnehr: "Kaufm. ohne HR",
        tc_kg: "KG",
        tc_kgaa: "KGaA",
        tc_koerperschaft: "Körperschaft",
        tc_oeffbetrieb: "öff. Betrieb",
        tc_ohg: "OHG",
        tc_sonstigegenoss: "sonstige Genoss.",
        tc_sonstoeffr: "sonst. öff. R.",
        tc_stifftungoeffr: "Stiftung öff. R.",
        tc_stiftung: "Stiftung",
        tc_stiftungprivr: "Stiftung priv. R.",
        tc_uco: "u. CO",
        tc_ucokg: "u. CO KG",
        tc_vvag: "VVaG",
        tc_sonstiges: "Sonstiges",
    };

    static CountryTable = {
        tc_AF: "Afghanistan",
        tc_EG: "Ägypten",
        tc_AL: "Albanien",
        tc_DZ: "Algerien",
        tc_AD: "Andorra",
        tc_AO: "Angola",
        tc_AI: "Anguilla",
        tc_AQ: "Antarktis",
        tc_AG: "Antigua und Barbuda",
        tc_GQ: "Äquatorialguinea",
        tc_AR: "Argentinien",
        tc_AM: "Armenien",
        tc_AW: "Aruba",
        tc_AZ: "Aserbaidschan",
        tc_ET: "Äthiopien",
        tc_AU: "Australien",
        tc_BS: "Bahamas",
        tc_BH: "Bahrain",
        tc_BD: "Bangladesch",
        tc_BB: "Barbados",
        tc_BE: "Belgien",
        tc_BZ: "Belize",
        tc_BJ: "Benin",
        tc_BM: "Bermudas",
        tc_BT: "Bhutan",
        tc_MM: "Birma",
        tc_BO: "Bolivien",
        tc_BA: "Bosnien-Herzegowina",
        tc_BW: "Botswana",
        tc_BV: "Bouvetinsel",
        tc_BR: "Brasilien",
        tc_IO: "Britisch-Indischer Ozean",
        tc_BN: "Brunei",
        tc_BG: "Bulgarien",
        tc_BF: "Burkina-Faso",
        tc_BI: "Burundi",
        tc_CL: "Chile",
        tc_CN: "China",
        tc_CX: "Weihnachtsinsel",
        tc_CK: "Cookinseln",
        tc_CR: "Costa Rica",
        tc_DK: "Dänemark",
        tc_DE: "Deutschland",
        tc_DJ: "Djibuti",
        tc_DM: "Dominika",
        tc_DO: "Dominikanische Republik",
        tc_EC: "Ecuador",
        tc_SV: "El Salvador",
        tc_CI: "Elfenbeinküste",
        tc_ER: "Eritrea",
        tc_EE: "Estland",
        tc_FK: "Falklandinseln",
        tc_FO: "Färöer Inseln",
        tc_FJ: "Fidschi Inseln",
        tc_FI: "Finnland",
        tc_FR: "Frankreich",
        tc_GF: "französisch Guyana",
        tc_PF: "Französisch Polynesien",
        tc_TF: "Französisches Süd-Territorium",
        tc_GA: "Gabun",
        tc_GM: "Gambia",
        tc_GE: "Georgien",
        tc_GH: "Ghana",
        tc_GI: "Gibraltar",
        tc_GD: "Grenada",
        tc_GR: "Griechenland",
        tc_GL: "Grönland",
        tc_UK: "Großbritannien",
        tc_GB: "Großbritannien (UK)",
        tc_GP: "Guadeloupe",
        tc_GU: "Guam",
        tc_GT: "Guatemala",
        tc_GN: "Guinea",
        tc_GW: "Guinea-Bissau",
        tc_GY: "Guyana",
        tc_HT: "Haiti",
        tc_HM: "Heard und McDonald Islands",
        tc_HN: "Honduras",
        tc_HK: "Hong Kong",
        tc_IN: "Indien",
        tc_ID: "Indonesien",
        tc_IQ: "Irak",
        tc_IR: "Iran",
        tc_IE: "Irland",
        tc_IS: "Island",
        tc_IL: "Israel",
        tc_IT: "Italien",
        tc_JM: "Jamaika",
        tc_JP: "Japan",
        tc_YE: "Jemen",
        tc_JO: "Jordanien",
        tc_YU: "Jugoslawien",
        tc_KY: "Kaiman Inseln",
        tc_KH: "Kambodscha",
        tc_CM: "Kamerun",
        tc_CA: "Kanada",
        tc_CV: "Kap Verde",
        tc_KZ: "Kasachstan",
        tc_KE: "Kenia",
        tc_KG: "Kirgisistan",
        tc_KI: "Kiribati",
        tc_CC: "Kokosinseln",
        tc_CO: "Kolumbien",
        tc_KM: "Komoren",
        tc_CG: "Kongo",
        tc_CD: "Kongo, Demokratische Republik",
        tc_HR: "Kroatien",
        tc_CU: "Kuba",
        tc_KW: "Kuwait",
        tc_LA: "Laos",
        tc_LS: "Lesotho",
        tc_LV: "Lettland",
        tc_LB: "Libanon",
        tc_LR: "Liberia",
        tc_LY: "Libyen",
        tc_LI: "Liechtenstein",
        tc_LT: "Litauen",
        tc_LU: "Luxemburg",
        tc_MO: "Macao",
        tc_MG: "Madagaskar",
        tc_MW: "Malawi",
        tc_MY: "Malaysia",
        tc_MV: "Malediven",
        tc_ML: "Mali",
        tc_MT: "Malta",
        tc_MP: "Marianen",
        tc_MA: "Marokko",
        tc_MH: "Marshallinseln",
        tc_MQ: "Martinique",
        tc_MR: "Mauretanien",
        tc_MU: "Mauritius",
        tc_YT: "Mayotte",
        tc_MK: "Mazedonien",
        tc_MX: "Mexiko",
        tc_FM: "Mikronesien",
        tc_MZ: "Mocambique",
        tc_MD: "Moldavien",
        tc_MC: "Monaco",
        tc_MN: "Mongolei",
        tc_MS: "Montserrat",
        tc_NA: "Namibia",
        tc_NR: "Nauru",
        tc_NP: "Nepal",
        tc_NC: "Neukaledonien",
        tc_NZ: "Neuseeland",
        tc_NI: "Nicaragua",
        tc_NL: "Niederlande",
        tc_AN: "Niederländische Antillen",
        tc_NE: "Niger",
        tc_NG: "Nigeria",
        tc_NU: "Niue",
        tc_KP: "Nord Korea",
        tc_NF: "Norfolkinsel",
        tc_NO: "Norwegen",
        tc_OM: "Oman",
        tc_AT: "Österreich",
        tc_PK: "Pakistan",
        tc_PS: "Palästina",
        tc_PW: "Palau",
        tc_PA: "Panama",
        tc_PG: "Papua-Neuguinea",
        tc_PY: "Paraguay",
        tc_PE: "Peru",
        tc_PH: "Philippinen",
        tc_PN: "Pitcairn",
        tc_PL: "Polen",
        tc_PT: "Portugal",
        tc_PR: "Puerto Rico",
        tc_QA: "Qatar",
        tc_RE: "Reunion",
        tc_RW: "Ruanda",
        tc_RO: "Rumänien",
        tc_RU: "Russland",
        tc_LC: "Saint Lucia",
        tc_ZM: "Sambia",
        tc_AS: "Samoa",
        tc_WS: "Samoa",
        tc_SM: "San Marino",
        tc_ST: "Sao Tome",
        tc_SA: "Saudi Arabien",
        tc_SE: "Schweden",
        tc_CH: "Schweiz",
        tc_SN: "Senegal",
        tc_SC: "Seychellen",
        tc_SL: "Sierra Leone",
        tc_SG: "Singapur",
        tc_SK: "Slowakei",
        tc_SI: "Slowenien",
        tc_SB: "Salomonen",
        tc_SO: "Somalia",
        tc_GS: "South Georgia, South Sandwich Isl.",
        tc_ES: "Spanien",
        tc_LK: "Sri Lanka",
        tc_SH: "St. Helena",
        tc_KN: "St. Kitts und Nevis",
        tc_PM: "St. Pierre und Miquelon",
        tc_VC: "St. Vincent",
        tc_KR: "Südkorea",
        tc_ZA: "Südafrika",
        tc_SD: "Sudan",
        tc_SR: "Surinam",
        tc_SJ: "Svalbard und Jan Mayen Islands",
        tc_SZ: "Swasiland",
        tc_SY: "Syrien",
        tc_TJ: "Tadschikistan",
        tc_TW: "Taiwan",
        tc_TZ: "Tansania",
        tc_TH: "Thailand",
        tc_TP: "Timor",
        tc_TG: "Togo",
        tc_TK: "Tokelau",
        tc_TO: "Tonga",
        tc_TT: "Trinidad Tobago",
        tc_TD: "Tschad",
        tc_CZ: "Tschechische Republik",
        tc_TN: "Tunesien",
        tc_TR: "Türkei",
        tc_TM: "Turkmenistan",
        tc_TC: "Turks und Kaikos Inseln",
        tc_TV: "Tuvalu",
        tc_UG: "Uganda",
        tc_UA: "Ukraine",
        tc_HU: "Ungarn",
        tc_UY: "Uruguay",
        tc_UZ: "Usbekistan",
        tc_VU: "Vanuatu",
        tc_VA: "Vatikan",
        tc_VE: "Venezuela",
        tc_AE: "Vereinigte Arabische Emirate",
        tc_US: "Vereinigte Staaten von Amerika",
        tc_VN: "Vietnam",
        tc_VG: "Virgin Island (Brit.)",
        tc_VI: "Virgin Island (USA)",
        tc_WF: "Wallis et Futuna",
        tc_BY: "Weissrussland",
        tc_EH: "Westsahara",
        tc_CF: "Zentralafrikanische Republik",
        tc_ZW: "Zimbabwe",
        tc_CY: "Zypern",
        tc_AC: "Ascension",
        tc_PT_20: "Azoren",
        tc_GG: "Guernsey",
        tc_JE: "Jersey",
        tc_XK: "Kosovo",
        tc_PT_30: "Madeira",
        tc_IM: "Isle of Man",
        tc_UM_71: "Midway",
        tc_ME: "Montenegro",
        tc_IN_AN: "Nikobaren",
        tc_TL: "Osttimor",
        tc_MU_RO: "Rodriguez",
        tc_RS: "Serbien",
        tc_SS: "Südsudan",
        tc_TA: "Tristan da Cunha",
        tc_UM_79: "Wake Island",
    };

    static ConsultationOccasionTable = {
        PRODUCT: "Produktberatung",
        OCCASION: "Anlassberatung",
        GLOBAL: "Globalberatung",
    };

    static ChangeTypeTable = {
        ADDITION: "Neugeschäft",
        CHANGE: "Änderungsgeschäft",
        REMOVAL: "Löschung im Änderungsgeschäft",
    };

    static MatchingModeTable = {
        VALUE: "VALUE",
        EVENT: "EVENT",
    };

    static SalesTypeTable = {
        internet: "Internet",
        phone: "telefonisch",
        personal: "persönlich",
    };

    static TenantTypeTable = {
        Zurich: "Zurich",
        DA: "DA",
        makler: "Makler",
        DB: "Deutsche Bank",
        BoFi: "BoFi",
    };

    static asList(dict: Record<string, string>) {
        return Object.keys(dict).map((key) => {
            return {
                Data: key,
                Readable: dict[key],
            } as DataReadable;
        });
    }
}
